<div class="xux-input-checkbox-group">
  <h3 class="xux-title" *ngIf="blockTitle">{{ blockTitle | translate }}</h3>
  <xux-widget-boilerplate [field]="field">
    <div class="checkbox-group" [ngClass]="twoColumnLayout ? 'grid-display' : 'scroll-area vertical-auto-scroll'">
      <a *ngIf="!(field?.disabledObs | async) && showSelectAll" class="select-all-link" (click)="selectAll()">{{ selectAllLinkText | translate}}</a>

      <ng-container *ngFor="let item of options">
        <div
          class="checkbox-item {{item.itemClass}}"
          [class.disabled]="item.disabled"
          [hidden]="item.hidden"
        >
          <label>
            <input type="checkbox"
              [attr.id]="item.value"
              [attr.value]="item.value"
              [disabled]="item.disabled || field.disabled"
              [checked]="item.selected"
              (click)="itemClicked($event, item.value)"
            />
            {{ item.text | translate }}
          </label>
        </div>
      </ng-container>
    </div>
  </xux-widget-boilerplate>
</div>
